export const EMPLOYEE_PERFORMANCE_PAGE_UUID =
  'b1bec957-ad6b-4345-80d8-387b839df224'
